module.exports = __webpack_public_path__ + "teqbahn-assets/media/3.c69cd99f.png";